export default __webpack_public_path__ + "static/media/wizard.a74f83f3.gif";